module.exports = __webpack_public_path__ + "static/logosHorizontal_Part1-563574fc8c197c2a832294f642481f34.png";